var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipToFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0.5H3.5C2.945 0.5 2.5 0.95 2.5 1.5V6.5C2.5 7.05 2.945 7.5 3.5 7.5H8.5C9.05 7.5 9.5 7.05 9.5 6.5V1.5C9.5 0.95 9.05 0.5 8.5 0.5ZM0.5 3.5H1.5V2.5H0.5V3.5ZM0.5 5.5H1.5V4.5H0.5V5.5ZM0.5 7.5H1.5V6.5H0.5V7.5ZM1.5 8.5V9.5C0.945 9.5 0.5 9.05 0.5 8.5H1.5ZM7.5 9.5H6.5V8.5H7.5V9.5ZM3.5 6.5H8.5V1.5H3.5V6.5ZM4.5 9.5H5.5V8.5H4.5V9.5ZM3.5 9.5H2.5V8.5H3.5V9.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipToFront);
export default __webpack_public_path__ + "static/media/flip_to_front.b074a3211685f3d63a786775d77d8e1c.svg";
export { ForwardRef as ReactComponent };